import type { HighlightOptions } from '@tiptap/extension-highlight';
import { Highlight } from '@tiptap/extension-highlight';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    commentHighlight: {
      /**
       * Set a highlight mark
       */
      setCommentHighlight: (attributes?: { commentState: string; commentId: string }) => ReturnType;
      /**
       * Unset a highlight mark
       */
      unsetCommentHighlight: () => ReturnType;
    };
  }
}

const stateColorMap = {
  Draft: '#E4E8EE',
  Active: '#FCF3C0',
  Selected: '#FFD651',
};

const colorStateMap = {
  '#E4E8EE': 'Draft',
  '#FCF3C0': 'Active',
  '#FFD651': 'Selected',
};

export const CommentHighlight = Highlight.extend<HighlightOptions>({
  name: 'commentHighlight',

  addAttributes() {
    return {
      commentState: {
        default: null,
        parseHTML: element => {
          const color = element.getAttribute('data-color') || element.style.backgroundColor;

          return colorStateMap[color] || 'Draft';
        },
        renderHTML: attributes => {
          if (!attributes.commentState) {
            return {};
          }
          const color = stateColorMap[attributes.commentState] || '#E4E8EE';

          return {
            'data-color': color,
            style: `background-color: ${color}; color: inherit`,
          };
        },
      },
      commentId: {
        default: null,
        parseHTML: element => element.getAttribute('data-comment-id'),
        renderHTML: attributes => {
          if (!attributes.commentId) {
            return {};
          }

          return {
            'data-comment-id': attributes.commentId,
          };
        },
      },
    };
  },

  excludes: '',

  addCommands() {
    return {
      setCommentHighlight: attributes => ({ commands }) => commands.setMark(this.name, attributes),
      unsetCommentHighlight: () => ({ commands }) => commands.unsetMark(this.name),
    };
  },
});
